import { createConnectToStoreDecorator } from "./redux-decorator-factory";
import { property } from "lit/decorators.js";

export function createConnectedProperty(store) {
  return (selector: (state: any) => any, options: any = {}) => {
    const connectToStore = createConnectToStoreDecorator(store);
    return (target: any, propertyKey: string): void => {
      property(options)(target, propertyKey);
      connectToStore(selector)(target, propertyKey);
    };
  };
}
